import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  styled as muiStyled,
} from '@mui/material';
import { styled } from '@mui/system';
import {
  createFileRoute,
  Link,
  Outlet,
  useMatchRoute,
} from '@tanstack/react-router';
import KeyIcon from 'icons/Key.icon';
import SettingsIcon from 'icons/Settings.icon';
import SubscriptionIcon from 'icons/Subscription.icon';
import UserEditIcon from 'icons/UserEdit.icon';

export const Route = createFileRoute('/(dashboard)/_dashboard/profile')({
  component: RouteComponent,
});

const links = [
  {
    to: '/profile/info',
    label: 'Profile',
    icon: (isActive: false | Record<never, string>) => (
      <UserEditIcon color={isActive ? 'var(--Interviewer-Green)' : 'var(--Interviewer-Black)'} />
    ),
  },
  {
    to: '/profile/password',
    label: 'Edit Password',
    icon: (isActive: false | Record<never, string>) => (
      <KeyIcon color={isActive ? 'var(--Interviewer-Green)' : 'var(--Interviewer-Black)'} />
    ),
  },
  // {
  //   to: '/profile/preferences',
  //   label: 'Preferences',
  //   icon: (isActive: false | Record<never, string>) => (
  //     <SettingsIcon color={isActive ? 'var(--Interviewer-Green)' : 'var(--Interviewer-Black)'} />
  //   ),
  // },
  // {
  //   to: '/profile/subscriptions',
  //   label: 'Manage Subscriptions',
  //   icon: (isActive: false | Record<never, string>) => (
  //     <SubscriptionIcon
  //       color={isActive ? 'var(--Interviewer-Green)' : 'var(--Interviewer-Black)'}
  //     />
  //   ),
  // },
];


const StyledContainer = muiStyled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  background: '#ffffff',
  borderRadius: '24px',
  border: '1px solid var(--Light-Gray)',
  boxShadow: '0px 1px 2px 0px #0205111A',
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    // margin: '32px',
  },
}));

const StyledList = muiStyled(List)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  flex: 'none',
  borderBottom: '1px solid #F0F1F3',
  height: 'auto',
  gap: '8px',
  padding: '16px',
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    flex: 1,
    borderRight: '1px solid #F0F1F3',
    borderBottom: 'none',
    height: '687px',
    gap: 0,
    padding: 0,
  },
}));

function RouteComponent() {
  const matchRoute = useMatchRoute();

  return (
    <Box sx={{
        padding: {xs: '14px 16px', md: '33px 43px'} 
    }}>
      {/* <StyledHeader>
        <Typography variant="h1">My Profile</Typography>
      </StyledHeader> */}

      <StyledContainer>
        <StyledList>
          <Typography 
            variant="h2" 
            sx={{ 
              padding: { xs: '16px', lg: '32px' },
              display: { xs: 'none', lg: 'block' },
              width: '100%'
            }}
          >
            Settings
          </Typography>
          {links.map((link) => {
            const isActive = matchRoute({ to: link.to });
            return (
              <ListItem 
                key={link.to} 
                disablePadding 
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  height: 'auto',
                  width: { xs: 'calc(50% - 4px)', lg: '100%' }
                }}
              >
                <ListItemButton
                  component={Link}
                  to={link.to}
                  sx={{
                    background: isActive
                      ? 'var(--Lightest-Green)'
                      : 'transparent',
                    color: isActive ? 'var(--Interviewer-Green)' : 'inherit',
                    borderRadius: { xs: '8px', lg: 0 },
                    maxHeight: { xs: 'auto', lg: '56px' },
                    padding: { xs: '12px', lg: '32px 16px 32px 32px' },
                    height: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    border: { xs: '1px solid var(--Light-Gray)', lg: 'none' },
                    width: '100%', // full width for proper spacing
                    gap: '8px',
                  }}
                >
                  {link.icon(isActive)}
                  <ListItemText
                    primary={link.label}
                    slotProps={{
                      primary: {
                        sx: {
                          fontWeight: 600,
                          fontSize: '14px',
                          lineHeight: '20px',
                          color: isActive
                            ? 'var(--Interviewer-Green)'
                            : 'var(--Interviewer-Black)',
                          textAlign: 'left',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: 'vertical',
                          wordBreak: 'break-word',
                          flex: 1,
                        },
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
              <ListItem 
                sx={{ 
                  margin: { xs: '0 16px', lg: 'auto 16px 16px' },
                  display: { xs: 'none', lg: 'block' },
                  width: '100%'
                }}
              >
                <Link
                  to="/login"
                  style={{ color: 'var(--Red-Error-Color', textDecoration: 'none' }}
                
                >
                  Delete account
                </Link>
              </ListItem>
        </StyledList>

        <Box sx={{ flex: { xs: 'none', lg: 4 }, padding: { xs: '16px', lg: '32px' } }}>
          <Outlet />
        </Box>
      </StyledContainer>
    </Box>
  );
}
